import styled from "styled-components";
import { styledByTheme } from "../../../../../themes/architecture/styled-by-theme";

export const GenericSideMenuLinkDefaultBox = styled.div<{active?: boolean}>`
    display: flex;
    align-items: center;
    padding: 0.8rem 0;
    font-size: 1.3rem;
    line-height: 1;
    background-color: ${({theme, active}) => active ? theme.colors.backgroundActive : theme.colors.background};
    color: ${({theme, active}) => active ? theme.colors.textActive: theme.colors.text};
    transition: color 0.2s ease;
    @media ${({theme}) => theme.mediaQuery.lowHeight}, ${({theme}) => theme.mediaQuery.xlAndBelow} {
        padding: 0.25rem 0;
    }
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        ${({theme}) => theme.font.presets.regular};
        padding: 1rem 0;
        color: ${({theme, active}) => active ? theme.colors.textActive: theme.colors.textLight};
        font-size: 1.6rem;
        font-weight: 300;
    }
    &:hover {
        color: ${({theme}) => theme.colors.textHover};
        background-color: ${({theme}) => theme.colors.backgroundHover};
    }
`;

const GenericSideMenuLinkCasino777Box = styled(GenericSideMenuLinkDefaultBox)`
    padding: 0.8rem 0.2rem;
    font-size: 1.4rem;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        padding: 1rem;
        font-weight: 400;
        ${({theme}) => theme.font.presets.body};
    }

`;

const GenericSideMenuLinkHarrahsWsopBox = styled(GenericSideMenuLinkDefaultBox)`
    ${({theme}) => theme.font.presets.regular};
    @media ${({theme}) => theme.mediaQuery.lowHeight}, ${({theme}) => theme.mediaQuery.xlAndBelow} {
        padding: 0.5rem 0;
    }
`;

export const GenericSideMenuLinkBox = styledByTheme(GenericSideMenuLinkDefaultBox)
    .forCasino777(GenericSideMenuLinkCasino777Box)
    .forHarrahs(GenericSideMenuLinkHarrahsWsopBox)
    .forWsop(GenericSideMenuLinkHarrahsWsopBox)
    .apply();
